// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vh1tj","right":"styles_right__2WY5K"};